export const CONTACT_ID_PARAM_NAME = 'contactId' as const

export const CONTACT_LIST_FOLDER_ID_PARAM_NAME = 'folderId' as const

export const contactsListsFoldersRouteName = 'user.contacts.listsFolders'

export const contactsListFolderRouteName = 'user.contacts.listsFolders.folder'

export const contactsListsFoldersContactListRouteName = 'user.contacts.listsFolders.contactListDetails'

export const contactsListFolderContactListRouteName = 'user.contacts.listsFolders.folder.contactListDetails'
